import React from "react";
import { Box, Chip, Grid, LinearProgress, Typography } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useParams } from "react-router-dom";
import { useGetContractManagementClaimAgeingAnalysisQuery, useGetContractManagementClaimOrderQuery } from "store/slices/apis/contractManagementDashboardSlice";
import DashboardPanelHeader from "components/DashboardPanelHeader";


// const claimsData = [
//   {
//     name: "0 to 7 days",
//     amount: 13,
//     days: 4,
//     color: colorPalette[0],
//   },
//   {
//     name: "8 to 14 days",
//     amount: 10,
//     days: 8,
//     color: colorPalette[1],
//   },
//   {
//     name: "15 to 30 days",
//     amount: 40,
//     days: 3,
//     color: colorPalette[2],
//   },
//   {
//     name: "> 30 days",
//     amount: 21,
//     days: 6,
//     color: colorPalette[3],
//   },
// ];

const ClaimsAgeing = (props) => {

  const { RaisedType } = props

  const { projectId } = useParams();
  const params = {
      projectId: projectId,
      raisedType: RaisedType
    }
  
  const { data, isLoading, isFetching } = useGetContractManagementClaimAgeingAnalysisQuery(params)
  const { data: ClaimData, isLoading: loading, } = useGetContractManagementClaimOrderQuery(params);

  const colorPalette = ["#3B00ED", "#9C27B0", "#D81B60", "#FF9800"];



  const totalDays = data?.data?.buckets.reduce((sum, item) => sum + item.count, 0);

  // const totalAmount = claimsData.reduce((sum, item) => sum + item.amount, 0);

  const getPercentValue = (item) => {
    const value = Math.floor((item.count / totalDays) * 100);
    return value;
  };

  const options = {
    chart: {
      type: "pie",
      backgroundColor: "transparent",
      height: 170,
      width: 170,
      events: {
        render: function () {
          const chart = this;

          if (chart.customCenterText) {
            chart.customCenterText.destroy();
            chart.customSubText.destroy();
          }

          const centerX = chart.plotLeft + chart.plotWidth / 2;
          const centerY = chart.plotTop + chart.plotHeight / 2;

          chart.customCenterText = chart.renderer
            .text(`${ClaimData?.data.approvalRate}%`, centerX, centerY - 5)
            .css({
              fontSize: "24px",
              fontWeight: "bold",
              fontFamily: "Outfit, sans-serif",
              color: "#000",
              textAnchor: "middle",
            })
            .attr({ align: "center" })
            .add();

          chart.customSubText = chart.renderer
            .text("Approval Rate", centerX, centerY + 18)
            .css({
              fontSize: "14px",
              fontFamily: "Outfit, sans-serif",
              color: "#737791",
              textAnchor: "middle",
            })
            .attr({ align: "center" })
            .add();
        },
      },
    },

    title: { text: null },

    plotOptions: {
      pie: {
        innerSize: "80%",
        dataLabels: { enabled: false },
        borderRadius: 0,
        borderWidth: 1,
        borderColor: "#fff",
        size: "120%",
      },
    },

    series: [
      {
        data: data?.data?.buckets.map((item, ind) => ({
          name: item.name,
          y: getPercentValue(item),
          color: colorPalette[ind],
        })),
      },
    ],

    tooltip: {
      useHTML: true,
      formatter: function () {
        const percent = this.y;
        return `
                    <div style="padding:6px 8px;">
                        <b>${this.point.name}</b><br/>
                        Percentage: ${percent}%<br/>
                       
                    </div>
                `;
      },
    },

    credits: { enabled: false },
  };

  return (
    <>
      <DashboardPanelHeader eyebrow="Commercial ageing" title="Claim Ageing" subtitle="Identify older claims requiring resolution or escalation." />
      <Grid container spacing={0} sx={{ display: "none" }}>
        <Grid
          size={12}
          sx={
            {
              // borderBottom: "1px solid #E5E5E5"
            }
          }
        >
          <Box
            sx={{
              p: "16px 16px 0px 16px",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: "20px",
                color: "#111216",
                lineHeight: "100%",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              Claims Ageing Analysis
            </Typography>
            {/* <IconButton sx={{ p: 0.5 }}>
                            <BsThreeDotsVertical color="#333436" size={18} />
                        </IconButton> */}
          </Box>
          <Grid size={12}>
            <Box sx={{ p: "0px 16px 16px 16px" }}>
              <Typography
                variant="body2"
                sx={{
                  fontFamily: "Outfit, sans-serif",
                  fontWeight: 500,
                  fontSize: "14px",
                  letterSpacing: "0px",
                  color: "#7D7F81",
                }}
              >
                Track Claims by age buckets to identify overdue claims requiring
                escalation.
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={1} sx={{ p: 2 }}>
        <Grid
          size={{ xs: 12, md: 8 }}
          sx={{ alignContent: "flex-start", mt: "19px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              pl: "24px",
            }}
          >
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: { xs: "18px", sm: "18px", md: "18px" },
                lineHeight: { xs: "16px", md: "24px" },
                color: "#000000",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              Average Claim Resolution
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: "28px",
                lineHeight: "100%",
                color: "#000000",
                fontFamily: "Outfit, sans-serif",
              }}
            >
              {ClaimData?.data.averageResolutionDays} Days
            </Typography>
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 4 }}>
          <Box
            sx={{
              //position: 'relative',
              // width: '150px',
              // height: '130px',
              margin: "0 auto",
            }}
          >
            <HighchartsReact highcharts={Highcharts} options={options} />
          </Box>
        </Grid>

        <Grid size={12}>
          {data?.data?.buckets.map((item, index) => (
            <Box
              key={index}
              sx={{ width: "100%", mt: index === 0 ? "6px" : "12px", p: "0" }}
            >
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mb: 1 }}
              >
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "14px",
                    color: "#00000099",
                    fontFamily: "Outfit, sans-serif",
                    lineHeight: "20px",
                    letterSpacing: "0.25px",
                  }}
                >
                  {item.name}
                </Typography>
                <Box
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr auto",
                    gap: 1.5,
                  }}
                >
                  <Chip
                    label={`INR ${item.totalValue} Cr`}
                    sx={{
                      fontWeight: 600,
                      fontSize: "11px",
                      color: "#433F5E",
                      fontFamily: "Outfit, sans-serif",
                      bgcolor: "#E7E7EB",
                      p: "2px 16px",
                      borderRadius: "5px",
                      height: "auto",
                    }}
                  />
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "#00000099",
                      fontFamily: "Outfit, sans-serif",
                      lineHeight: "20px",
                      letterSpacing: "0.25px",
                    }}
                  >
                    {item.count}
                  </Typography>
                </Box>
              </Box>
              <LinearProgress
                variant="determinate"
                value={getPercentValue(item)}
                sx={{
                  height: 4,
                  borderRadius: 5,
                  backgroundColor: "#E8EAED",
                  "& .MuiLinearProgress-bar": {
                    backgroundColor: colorPalette[index],
                    borderRadius: 5,
                  },
                }}
              />
            </Box>
          ))}
        </Grid>
      </Grid>
    </>
  );
};

export default ClaimsAgeing;
